import { render, staticRenderFns } from "./send-message-x.vue?vue&type=template&id=85fc5300&scoped=true"
import script from "./send-message-x.vue?vue&type=script&lang=js"
export * from "./send-message-x.vue?vue&type=script&lang=js"
import style0 from "./send-message-x.vue?vue&type=style&index=0&id=85fc5300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fc5300",
  null
  
)

export default component.exports